<template>
  <div class="ph-dialog">
    <van-dialog
      v-model="show"
      :title="title"
      :confirm-button-text="confirmButtonText"
      :cancel-button-text="cancelButtonText"
      @confirm="confirm"
      @cancel="close"
      show-cancel-button
    >
      <div v-html="message" class="ph-dialog-content"></div>
      <div slot="title" v-show="closeOnClickOverlay" @click="show = false">
        <van-icon size="1.2rem" name="cross" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      closeOnClickOverlay: false,
      message: "",
      title: "",
      confirmButtonText: "",
      cancelButtonText: "",
      show: false,
      close: () => {},
      confirm: () => {}
    };
  }
};
</script>

<style lang="less">
.ph-dialog {
  .van-dialog__header {
    padding-top: 10px;
    i {
      float: right;
      margin-right: 0.5rem;
    }
  }

  &-content {
    margin: 1rem 1rem;
    text-align: center;
  }
}
</style>
